import React, { useState } from 'react';
import LSMedInputWithButton from '../LSMedInputWithButton'
import PropTypes from 'prop-types';
import ChatList from '../ChatList/ChatList';
import LoginButton from '../LoginButton';
import { auth } from '../../config/firebase';

const ChatContainer = ({
  resetBot,
  messages,
  onUserInput,
  botMessageStatus,
}) => {

  const [showChatContainer, setShowChatContainer] = useState(auth.currentUser ? true : false);

  return (
    <div className="ibm-col-lg-16 ibm-col-md-16 ibm-col-sm-16 chat-container" style={{ display: showChatContainer ? "flex" : "none" }}>
      <div className="ibm-lg-col-16 ibm-padding chat-container__header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <p className="ibm-type-a">
          LET'S PLAN YOUR BEST CARE TOGETHER!
        </p>
        <div>
          <LoginButton setShowChatContainer={setShowChatContainer} resetBot={resetBot} />
        </div>
      </div>
      {' '}
      <div
        id="chat-container__list-wrapper"
        className="chat-container__list-wrapper"
      >
        {
          setShowChatContainer && <ChatList
            messages={messages}
            onUserInput={onUserInput}
            botMessageStatus={botMessageStatus}
          />
        }

        {' '}

      </div>
      {' '}
      <div className="ibm-lg-col-4 ibm-padding chat-container__input">
        <LSMedInputWithButton
          id="input_field"
          onSubmit={
            (target) => {
              onUserInput('user', target.value);
              target.value = '';
            }
          }
          placeholder="Type here..."
        />
      </div>
      {' '}

    </div>
  );
}

ChatContainer.defaultProps = {
  botMessageStatus: null,
};

ChatContainer.propTypes = {
  messages: PropTypes.array.isRequired,
  onUserInput: PropTypes.func.isRequired,
  botMessageStatus: PropTypes.string,
};

export default ChatContainer;



// WEBPACK FOOTER //
// ./src/components/ChatContainer/ChatContainer.js